import { render, staticRenderFns } from "./HebrewSearch.vue?vue&type=template&id=3be897e7&scoped=true&"
import script from "./HebrewSearch.vue?vue&type=script&lang=js&"
export * from "./HebrewSearch.vue?vue&type=script&lang=js&"
import style0 from "./HebrewSearch.vue?vue&type=style&index=0&id=3be897e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be897e7",
  null
  
)

export default component.exports